/** Localized summary for a date range from already-formatted start/end strings, with a fallback when both are empty. */
export function formatDateRangeSummary(
	t: (key: string, named?: Record<string, unknown>) => string,
	start: string | null | undefined,
	end: string | null | undefined,
	fallback: string,
): string {
	if (start && end) return t('date_range_picker.summary_range', { start, end });
	if (end) return t('date_range_picker.summary_before_end', { end });
	if (start) return t('date_range_picker.summary_from_start', { start });
	return fallback;
}
